import { createAnalyticsEvent } from 'analytics/create-analytics-event';
import { GAEventName } from 'analytics/ga-event-name.enum';

type BannerClickEventPayload = {
  bannerType: string;
  bannerHeadline?: string;
  bannerLink: string;
  clickDate: string;
};

export const bannerClickEvent = createAnalyticsEvent(
  ({ bannerType, bannerHeadline, bannerLink, clickDate }: BannerClickEventPayload) => ({
    event: GAEventName.BANNER_CLICK,
    bannerType,
    bannerHeadline,
    bannerLink,
    clickDate
  })
);
